import { render, staticRenderFns } from "./pwa-app.vue?vue&type=template&id=6252e42a"
import script from "./pwa-app.vue?vue&type=script&lang=js"
export * from "./pwa-app.vue?vue&type=script&lang=js"
import style0 from "./pwa-app.vue?vue&type=style&index=0&id=6252e42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports